import React from "react";
import Footer from "../organisms/Footer";
import Header from "../organisms/Header";
import styles from "../../styles/profilelayout.module.css";
import { Box } from "@chakra-ui/react";
import { useRouter } from "next/router";
function ProfileLayout({ children, fullWidth, showModal, setShowModal }) {
  const currentyear = new Date().getFullYear();
  const router = useRouter();

  return (
    <Box className={styles.layout}>
      {/* borderTop={"16px solid black"} */}

      {router?.route === "/" ? (
        ""
      ) : (
        <>
          <img
            className={styles.profile__top__leftBg}
            src="/new-ui/images/blog-top-left-bg.png"
          />
          <img
            className={styles.profile__top__rightBg}
            src="/new-ui/images/blog-top-right-bg.png"
          />

          <img
            className={styles.profile__Mid__leftBg}
            src="/new-ui/images/profleMid.png"
          />
          <img
            className={styles.profile__Mid__righttBg}
            src="/new-ui/images/profileRightCenter.png"
          />
          <img
            className={styles.profile__bottom__leftBg}
            src="/new-ui/images/profileBottomLeft.png"
          />
          {/* small bgs */}
          <img
            className={styles.blog__top__rightBgSM}
            src="/new-ui/images/blog-sm-top-right-bg.png"
          />
       
        </>
      )}

      <Box px={["0px", "20px", "30px", "50px", "50px", "210px"]} as="header">
        <Header showModal={showModal} setShowModal={setShowModal} />  
      </Box>
      <Box
        px={!fullWidth && ["0px", "20px", "30px", "50px", "50px", "210px"]}
        as="main"
        className={styles.main}
      >
        {children}
      </Box>
      <Box>
        <Box px={["0px", "20px", "30px", "50px", "50px", "210px"]} as="footer">
          <Footer />
        </Box>
        <Box as="p" className={styles.copyright}>
          Copyright © {currentyear} CoverClap All rights reserved.
        </Box>
      </Box>
    </Box>
  );
}

export default ProfileLayout;
